<template>
  <div
    v-if="globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') && globals.currentUserRole < 3"
  >
    <!-- This component displays the check management  -->

    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="checks-top-panel">
      <div class="panel-body top-button-bar">
        <div class="col-md-6">
          <!-- Add buttons here  -->
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getCheckData()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.CM0000 }}
          </button>
          <button
            id="check-management-create-button"
            class="btn btn-raised btn-top-bar"
            v-if="
              globals.isAccessAllowed('LoopOp_SurveyInstances_Create') && 
              globals.isAccessAllowed('LoopOp_SurveyInstancesLocations_ReadAll') &&
              (!feature.isAudiTarget || !globals.isAgencyUser)"
            @click="
              (selectedChecks = []),
              (selectedCheckIds = []),
              (showAddChecksDialog = true)"
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.CM0001 }}
          </button>
          <button
            id="check-management-edit-button"
            class="btn btn-raised btn-top-bar"
            v-if="
              globals.isAccessAllowed('LoopOp_SurveyInstancesProperties_Update') && 
              globals.isAccessAllowed('LoopOp_SurveyInstancesProperties_Create') &&
              (!feature.isAudiTarget || !globals.isAgencyUser)"
            @click="showEditChecksDialog = true"
            :disabled="includeChecks ? selectedCheckIds.length == 0 : selectedCheckIds.length == checkCount"
          >
            <i class="material-icons md-36">edit</i>
            <br />
            {{ lang.CM0002 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="showCheckPaymentModal = true"
            v-if="
              feature.isEnabled('settlement') &&
              globals.isPaymentsReadingAllowed &&
              !feature.isAudiTarget"
            :disabled="selectedChecks.length === 0"
          >
            <i class="material-icons md-36">attach_money</i>
            <br />
            {{ lang.CM0061 }}
          </button>
          <button
            id="check-management-assign-agency-button"
            class="btn btn-raised btn-top-bar"
            v-if="feature.isAudiTarget && globals.isLeadAgencyUser"
            @click="showCheckLocalAgencyAssignmentModal = true"
            :disabled="selectedChecks.length < 1"
          >
            <i class="material-icons md-36">assignment</i>
            <br />
            {{ lang.CM0075 }}
          </button>
          <button
            id="check-management-copy-check-button"
            class="btn btn-raised btn-top-bar"
            v-if="feature.isAudiTarget && globals.isLeadAgencyUser"
            @click="cloneSelectedChecks()"
            :disabled="selectedChecks.length < 1"
          >
            <i class="material-icons md-36">content_copy</i>
            <br />
            {{ lang.CM0076 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SurveyInstancesExport_Create')"
            @click="showExportModal = true"
            :disabled="!selectedClient"
          >
            <i class="material-icons md-36">get_app</i>
            <br />
            {{ lang.CM0004 }}
          </button>
          <button
            v-if="!globals.isAgencyUser"
            class="btn btn-raised btn-top-bar"
            @click="showAutovalidationDialog()"
            :disabled="selectedChecks.length < 1 || globals.isAgencyUser"
          >
            <i class="material-icons md-36">assignment_turned_in</i>
            <br />Autovalidate
          </button>
          <button
            class="btn btn-raised btn-top-bar top-btn-primary"
            v-if="globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read')"
            @click="openChecks()" 
            :disabled="selectedCheckIds.length < 1"
          >
            <i class="material-icons md-36">zoom_in</i>
            <br />
            {{ lang.CM0005 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAudiUser"
            @click="showCheckHistory()"
            :disabled="selectedCheckIds.length != 1"
          >
            <i class="material-icons md-36">history</i>
            <br />
            {{ lang.CM0080 }}
          </button>
        </div>
        <div class="col-md-6 nopadding">
          <div class="well well-top-bar">
            <div class="form-group selectbar">
              <div class="btn-group" id="statusCodeUpdateSelection">
                <a
                  role="button"
                  class="btn btn-default btn-raised"
                  @click="changeSelectedChecksStatus()"
                  :disabled="
                    !selectedStatusCode ||
                    selectedChecks.length == 0 ||
                    !globals.isAccessAllowed('LoopOp_SurveyInstances_Update')"
                >{{ lang.CM0006 }}: {{ selectedStatusCode }}</a>
                <a
                  role="button"
                  class="btn btn-default btn-raised dropdown-toggle"
                  data-toggle="dropdown"
                  :class="{disabled: allowedStatusCodes.length < 1 || !globals.isAccessAllowed('LoopOp_SurveyInstances_Update'),}"
                  :disabled="
                    allowedStatusCodes.length < 1 ||
                    !globals.isAccessAllowed('LoopOp_SurveyInstances_Update')"
                >
                  <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                  <li v-for="(code, key) in allowedStatusCodes" :key="key">
                    <a role="button" @click="selectedStatusCode = code">{{ getStatusCodeDescription(code) }}</a>
                  </li>
                </ul>
              </div>
              <b-tooltip
                ref="tooltip"
                target="statusCodeUpdateSelection"
                :delay="globals.tooltipDelay"
                v-if="
                  !filterStrings.SurveyInstanceStatusId &&
                  globals.isAccessAllowed('LoopOp_SurveyInstances_Update')"
              >{{ lang.CM0046 }}</b-tooltip>
              <a
                role="button"
                class="btn btn-raised"
                @click="togglePageSelected()"
              >
                <span v-if="isPageSelected() ? !includeChecks : includeChecks">{{ lang.CM0007 }}</span>
                <span v-else>{{ lang.CM0008 }}</span>
              </a>
              <button
                v-if="
                  feature.isEnabled('settlement') &&
                  globals.isPaymentsReadingAllowed &&
                  !feature.isAudiTarget"
                class="btn btn-raised btn-success"
                @click="showSettlementDownloadModal = true"
              >
                {{ lang.CM0059 }}
              </button>
              <!-- <a role="button" class="btn btn-raised" @click=";" disabled>
                <span>{{lang.CM0009}}</span>
              </a>-->
              <!-- <a role="button" class="btn btn-raised" @click="includeChecks = true, selectedChecks = []">
                <span>{{lang.CM0010}}</span>
              </a>-->
            </div>
          </div>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-6" style="min-height: 50px">
          <div class="form-group selectbar nopadding">
            <div
              class="select-filter-container"
              v-if="!feature.isAudiTarget || !feature.isEnabled('audi_importers')"
            >
              <select2
                class="form-control"
                id="check-management-clients-selector"
                ref="clientSelect"
                v-model="selectedClient"
                @change="onClientSelection()"
                :placeholder="lang.CM0011"
                :allowClear="true"
              >
                <option></option>
                <option
                  v-for="client in dataLists.clientList"
                  :key="client.ClientGuid"
                  :value="client.ClientGuid"
                >
                  {{ client.ClientName }}
                </option>
              </select2>
            </div>
            <div class="select-filter-container" v-else>
              <select2
                class="form-control"
                id="check-management-importer-selector"
                ref="importerSelect"
                v-model="selectedImporter"
                @change="getCheckData()"
                :placeholder="lang.CM0074"
                :allowClear="true"
              >
                <option></option>
                <option
                  v-for="importer in dataLists.importerList"
                  :key="importer.ImporterGuid"
                  :value="importer.ImporterGuid"
                >
                  {{ importer.ImporterName }}
                </option>
              </select2>
            </div>
            <div class="select-filter-container">
              <select2
                class="form-control"
                id="check-management-project-selector"
                ref="projectSelect"
                v-model="selectedProject"
                @change="onProjectSelection()"
                :disabled="!selectedClient"
                :placeholder="lang.CM0048"
                :allowClear="true"
              >
                <option></option>
                <option
                  v-for="project in dataLists.projectsOfClient"
                  :key="project.ProjectGuid"
                  :value="project.ProjectGuid"
                >
                  {{ project.ProjectName }}
                </option>
              </select2>
            </div>
            <div
              class="select-filter-container"
              :class="{ 'width-15': selectedCheckType === 'FO' }"
              v-if="globals.currentUserRole < 2 && !feature.isAudiTarget"
            >
              <select2
                class="form-control"
                v-model="selectedCheckType"
                @change="getCheckData()"
                :placeholder="lang.CM0066"
                :allowClear="true"
              >
                <option></option>
                <option value="FO">{{ lang.CM0063 }}</option>
                <option value="MA">{{ lang.CM0064 }}</option>
                <option value="AG">{{ lang.CM0065 }}</option>
              </select2>
            </div>
            <div
              class="select-filter-container width-15"
              v-if="selectedCheckType === 'FO'"
            >
              <a
                role="button"
                class="btn btn-default"
                style="margin: 0 0 2px 0"
                @click="toggleOnlineStateFilter()"
              >
                <i
                  class="material-icons md-24 text-primary"
                  v-if="selectedOnlineState === true"
                >check_box</i>
                <i
                  class="material-icons md-24"
                  v-else-if="selectedOnlineState === false"
                >check_box_outline_blank</i>
                <i class="material-icons md-24 text-primary" v-else>indeterminate_check_box</i>
                <span>{{ lang.CM0067 }}</span>
              </a>
            </div>
          </div>
        </div>

        <div class="col-lg-6 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
              >{{ lang.CM0012 }}</b-tooltip>
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                  >20</a>
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                  >50</a>
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                  >100</a>
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                  >200</a>
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                  >500</a>
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 1000 }"
                    role="button"
                    @click="updatePaging(1, 1000)"
                  >1000</a>
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: !pageCount || selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
              >{{ lang.CM0013 }}</b-tooltip>
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{disabled: !pageCount || selectedPage == pageCount,}"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
              >{{ lang.CM0014 }}</b-tooltip>
            </li>
            <li class="disabled">
              <a role="button" id="checksTotalElementsCounter">{{ checkCount }}</a>
              <b-tooltip
                ref="tooltip"
                target="checksTotalElementsCounter"
                :delay="globals.tooltipDelay"
              >{{ lang.CM0049 }}</b-tooltip>
            </li>
            <li>
              <button
                id="check-management-custom-settings"
                class="btn btn-raised"
                style="margin-left: 100px"
                @click="showCheckManagementFilterModal = true"
              >
                {{ lang.CM1074 }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <table
          class="table"
          style="word-wrap: break-word; table-layout: fixed"
          id="check-management-main-table"
        >
          <thead>
            <tr>
              <!-- Add table headers here -->
              <!-- The table sort is triggered by click on the header -->
              <th class="text-center" v-if="CheckManagementFilter.SID">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyId')"
                >
                  {{ lang.CM0015 }}
                  <span
                    v-if="sortField == 'SurveyId' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyId' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.CheckID">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceId')"
                >
                  {{ lang.CM0016 }}
                  <span
                    v-if="sortField == 'SurveyInstanceId' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceId' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.CheckCode">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('ShortSurveyCode')"
                >
                  {{ lang.CM0017 }}
                  <span
                    v-if="sortField == 'ShortSurveyCode' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'ShortSurveyCode' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Status">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceStatusId')"
                >
                  {{ lang.CM0018 }}
                  <span
                    v-if="sortField == 'SurveyInstanceStatusId' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceStatusId' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Project">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('ProjectName')"
                >
                  {{ lang.CM0019 }}
                  <span
                    v-if="sortField == 'ProjectName' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'ProjectName' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Wave">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('WaveName')"
                >
                  {{ lang.CM0020 }}
                  <span
                    v-if="sortField == 'WaveName' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'WaveName' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Scenario">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('ScenarioName')"
                >
                  {{ lang.CM0021 }}
                  <span
                    v-if="sortField == 'ScenarioName' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'ScenarioName' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.CheckInfo">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceInfo')"
                >
                  {{ lang.CM0073 }}
                  <span
                    v-if="sortField == 'SurveyInstanceInfo' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceInfo' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.StoreID">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('LocationStoreId')"
                >
                  {{ lang.CM0050 }}
                  <span
                    v-if="sortField == 'LocationStoreId' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'LocationStoreId' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.LocationName">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('LocationName')"
                >
                  {{ lang.CM0051 }}
                  <span
                    v-if="sortField == 'LocationName' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'LocationName' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Address">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('LocationAddress')"
                >
                  {{ lang.CM0022 }}
                  <span
                    v-if="sortField == 'LocationAddress' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'LocationAddress' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Country">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('LocationCountry')"
                >
                  {{ lang.CM0023 }}
                  <span
                    v-if="sortField == 'LocationCountry' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'LocationCountry' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Visit">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceAnswerDateOfVisit')"
                >
                  {{ lang.CM0024 }}
                  <span
                    v-if="sortField == 'SurveyInstanceAnswerDateOfVisit' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceAnswerDateOfVisit' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <!-- <th style="width:7%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceShopperSubmittedAt')"
                >
                  {{lang.CM0025}}
                  <span
                    v-if="sortField == 'SurveyInstanceShopperSubmittedAt' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceShopperSubmittedAt' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>-->
              <!-- <th style="width:7%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstancePartnerSubmittedAt')"
                >
                  {{lang.CM0026}}
                  <span
                    v-if="sortField == 'SurveyInstancePartnerSubmittedAt' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstancePartnerSubmittedAt' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>-->
              <th class="text-center" v-if="CheckManagementFilter.Internalnote">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceNote')"
                >
                  {{ lang.CM0027 }}
                  <span
                    v-if="sortField == 'SurveyInstanceNote' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceNote' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.ExpiryDate">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceUntil')"
                >
                  {{ lang.CM0028 }}
                  <span
                    v-if="sortField == 'SurveyInstanceUntil' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceUntil' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Agency">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceResponsable')"
                >
                  {{ feature.isAudiTarget ? lang.CM0065 : lang.CM0029 }}
                  <span
                    v-if="sortField == 'SurveyInstanceResponsable' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceResponsable' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center"
                v-if="feature.isAudiTarget && CheckManagementFilter.Shopper"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('ApprovedShopperName')"
                >
                  {{ lang.CM0079 }}
                  <span
                    v-if="sortField == 'ApprovedShopperName' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'ApprovedShopperName' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Score">
                <a
                  id="checkMgmtScoreColumnHeader"
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceScore')"
                >
                  {{ lang.CM0030 }}
                  <i class="material-icons md-18">help_outline</i>
                  <span
                    v-if="sortField == 'SurveyInstanceScore' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceScore' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
                <b-tooltip
                  ref="tooltip"
                  target="checkMgmtScoreColumnHeader"
                  :delay="globals.tooltipDelay"
                  >{{ lang.CM0052 }}</b-tooltip
                >
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Progress">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceProgress')"
                >
                  {{ lang.CM0031 }}
                  <span
                    v-if="sortField == 'SurveyInstanceProgress' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceProgress' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center"
                v-if="!feature.isAudiTarget && CheckManagementFilter.Progress"
              >
                <a
                  id="checkMgmtSettlementColumnHeader"
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SettlementStatus')"
                >
                  {{ lang.CM0060 }}
                  <i class="material-icons md-18">help_outline</i>
                  <span
                    v-if="sortField == 'SettlementStatus' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SettlementStatus' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
                <b-tooltip
                  ref="tooltip"
                  target="checkMgmtSettlementColumnHeader"
                  :delay="globals.tooltipDelay"
                >
                  {{ lang.CM0068 }}:
                  <br />
                  <br />
                  + &rarr; {{ lang.CM0069 }}
                  <br />
                  <br />
                  o &rarr; {{ lang.CM0070 }}
                  <br />
                  <br />
                  x &rarr; {{ lang.CM0071 }}
                  <br />
                  <br />
                  - &rarr; {{ lang.CM0072 }}
                </b-tooltip>
              </th>
              <th class="text-center" v-if="CheckManagementFilter.Modifiedat">
                <a
                  class="table-header"
                  role="button"
                  @click="sortCheckData('SurveyInstanceModifiedAt')"
                >
                  {{ lang.CM0047 }}
                  <span
                    v-if="sortField == 'SurveyInstanceModifiedAt' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyInstanceModifiedAt' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
            </tr>
            <tr class="table-filters">
              <th class="nopadding" v-if="CheckManagementFilter.SID">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyId"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.CheckID">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceId"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.CheckCode">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.ShortSurveyCode"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Status">
                <div
                  class="form-group filterbar"
                  id="checkMgmtStatusFilterContainer"
                >
                  <select2
                    class="form-control nopadding"
                    v-model="filterStrings.SurveyInstanceStatusId"
                    :allowClear="true"
                    :placeholder="lang.CM0032"
                  >
                    <option></option>
                    <option
                      v-for="status in dataLists.statusCodes.filter((c) => c.SurveyInstanceStatusId !== 900)"
                      :key="status.SurveyInstanceStatusId"
                      :value="status.SurveyInstanceStatusId"
                    >
                      {{ status.SurveyInstanceStatusId }}
                    </option>
                  </select2>
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Project">
                <div class="form-group filterbar">
                  <!-- <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.ProjectName"
                    @keyup.enter="selectedPage = 1, getCheckData()"
                    disabled
                  >-->
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Wave">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.WaveName"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Scenario">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.ScenarioName"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.CheckInfo">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceInfo"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.StoreID">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.LocationStoreId"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.LocationName">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.LocationName"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Address">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.LocationAddress"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Country">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.LocationCountry"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Visit">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceAnswerDateOfVisit"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <!-- <th class="nopadding" style="width:7%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceShopperSubmittedAt"
                    @keyup.enter="selectedPage = 1, getCheckData()"
                  >
                </div>
              </th>-->
              <!-- <th class="nopadding" style="width:7%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstancePartnerSubmittedAt"
                    @keyup.enter="selectedPage = 1, getCheckData()"
                  >
                </div>
              </th>-->
              <th class="nopadding" v-if="CheckManagementFilter.Internalnote">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceNote"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.ExpiryDate">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceUntil"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Agency">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceResponsable"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th
                class="nopadding"
                v-if="feature.isAudiTarget && CheckManagementFilter.Shopper"
              >
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.ApprovedShopperName"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Score">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceScore"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Progress">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceProgress"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th
                class="nopadding"
                v-if="!feature.isAudiTarget && CheckManagementFilter.Progress"
              >
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SettlementStatus"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
              <th class="nopadding" v-if="CheckManagementFilter.Modifiedat">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.CM0032"
                    v-model="filterStrings.SurveyInstanceModifiedAt"
                    @keyup.enter="(selectedPage = 1), getCheckData()"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody
            class="main-table-scrollbar"
            v-click-outside="clearLastSelection"
          >
            <tr
              role="button"
              v-for="check in checkData"
              :key="check.SurveyInstanceId"
              @click="selectCheck(check.SurveyInstanceGuid, check.SurveyInstanceId, $event)"
              @dblclick="
                globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read') &&
                !globals.isAudiUser &&
                openCheck(check.SurveyInstanceId)"
              :class="{info: isCheckSelected(check.SurveyInstanceGuid) ? includeChecks : !includeChecks,
                'text-red': check.SurveyInstanceIsExpired,
              }"
            >
              <!-- Add table data here -->
              <td v-if="CheckManagementFilter.SID">
                {{ check.SurveyId }}
              </td>
              <td v-if="CheckManagementFilter.CheckID">
                {{ check.SurveyInstanceId }}
              </td>
              <td v-if="CheckManagementFilter.CheckCode">
                {{ check.ShortSurveyCode }}
              </td>
              <td v-if="CheckManagementFilter.Status">
                {{ check.SurveyInstanceStatusId }}
              </td>
              <td v-if="CheckManagementFilter.Project">
                {{ check.ProjectName }}
              </td>
              <td v-if="CheckManagementFilter.Wave">{{ check.WaveName }}</td>
              <td v-if="CheckManagementFilter.Scenario">
                {{ check.ScenarioName }}
              </td>
              <td v-if="CheckManagementFilter.CheckInfo">
                {{ check.SurveyInstanceInfo }}
              </td>
              <td v-if="CheckManagementFilter.StoreID">
                {{ check.LocationStoreId }}
              </td>
              <td v-if="CheckManagementFilter.LocationName">
                {{ check.LocationName }}
              </td>
              <td v-if="CheckManagementFilter.Address">
                {{ check.LocationAddress }}
              </td>
              <td v-if="CheckManagementFilter.Country">
                {{ check.LocationCountry }}
              </td>
              <td v-if="CheckManagementFilter.Visit">
                {{ check.SurveyInstanceAnswerDateOfVisit }}
              </td>
              <!-- <td style="width:7%">{{ check.SurveyInstanceShopperSubmittedAt }}</td> -->
              <!-- <td style="width:7%">{{ check.SurveyInstancePartnerSubmittedAt }}</td> -->
              <td
                v-if="CheckManagementFilter.Internalnote"
                :id="`tdSurveyInstanceNote${check.SurveyInstanceId}`"
              >
                {{ globals.truncateString(check.SurveyInstanceNote, 30) }}
              </td>
              <b-tooltip
                :target="`tdSurveyInstanceNote${check.SurveyInstanceId}`"
                :delay="globals.tooltipDelay"
                boundary="viewport"
              >{{ check.SurveyInstanceNote }}</b-tooltip>

              <td v-if="CheckManagementFilter.ExpiryDate">
                {{ check.SurveyInstanceUntil }}
              </td>
              <td v-if="CheckManagementFilter.Agency">
                {{ check.SurveyInstanceResponsable }}
              </td>
              <td v-if="feature.isAudiTarget && CheckManagementFilter.Shopper">
                {{ check.ApprovedShopperName }}
              </td>
              <td v-if="CheckManagementFilter.Score">
                {{ check.SurveyInstanceScore }}
              </td>
              <td v-if="CheckManagementFilter.Progress">
                {{ check.SurveyInstanceProgress }}
              </td>
              <td
                v-if="!feature.isAudiTarget && CheckManagementFilter.Progress"
              >
                {{ check.SettlementStatus }}
              </td>
              <td v-if="CheckManagementFilter.Modifiedat">
                {{ check.SurveyInstanceModifiedAt }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for adding new checks -->
    <CheckManagementAddModal
      :dataLists="dataLists"
      :selectedClient="selectedClient"
      :selectedProject="selectedProject"
      :showDialog="showAddChecksDialog"
      @clientSelected="onClientSelection"
      @dialogClosed="onAddChecksDialogClosed"
      @dialogDataSaved="onAddChecksDialogDataSaved"
      @checksCreated="(selectedChecks = $event.guids), (selectedCheckIds = $event.ids)"
    ></CheckManagementAddModal>

    <!-- This modal is for editing checks -->
    <CheckManagementEditModal
      :dataLists="dataLists"
      :selectedChecks="selectedChecks"
      :selectedCheckIds="selectedCheckIds"
      :selectedClient="selectedClient"
      :selectedProject="selectedProject"
      :includeChecks="includeChecks"
      :showDialog="showEditChecksDialog"
      :projectSelected="!!selectedProject"
      @dialogClosed="onEditChecksDialogClosed"
    ></CheckManagementEditModal>

    <CheckManagementFilterModal
      :showModal="showCheckManagementFilterModal"
      @closeModal="(showCheckManagementFilterModal = false), getCustomSettingsList()"
    ></CheckManagementFilterModal>

    <SettlementDownloadModal
      :showModal="showSettlementDownloadModal"
      @closeModal="showSettlementDownloadModal = false"
    ></SettlementDownloadModal>

    <CheckPaymentModal
      :showModal="showCheckPaymentModal"
      :surveyInstanceGuids="selectedChecks"
      @modalClosed="(showCheckPaymentModal = false), getCheckData()"
    ></CheckPaymentModal>

    <ShopperFilterModal
      :showModal="showShopperFilterModal"
      :selectedClient="selectedClient"
      @modalClosed="showShopperFilterModal = false"
    ></ShopperFilterModal>

    <CheckLocalAgencyAssignmentModal
      v-if="feature.isAudiTarget && globals.isLeadAgencyUser"
      :showModal="showCheckLocalAgencyAssignmentModal"
      :selectedChecks="selectedChecks"
      :agencies="dataLists.agencyList"
      @modalClosed="showCheckLocalAgencyAssignmentModal = false"
      @modalDataSaved="getCheckData()"
    ></CheckLocalAgencyAssignmentModal>

    <!-- This modal is for selecting a file type and downloading check data -->
    <confirmation-dialog
      :confirmationTitle="lang.CM0038"
      :yesButtonText="lang.CM0039"
      :noButtonText="lang.CM0040"
      :showDialog="showExportModal"
      @onYesConfirmation="downloadCheckData"
      @dialogClosed="showExportModal = false"
    >
      <div class="form-group">
        <p>
          {{ lang.CM0041 }}:
          <b>{{ getNameOfSelectedClient() }}</b>
        </p>
        <!-- <p>{{lang.CM0042}}</p>
        <div class="col-md-8 col-md-offset-2" style="padding-bottom: 20px;">
          <select id="selectCheckExportFiletype" class="form-control" v-model="checkExportFileType">
            <option value="csv">{{lang.CM0043}}</option>
            <option value="xls">{{lang.CM0044}}</option>
            <option value="xlsx">{{lang.CM0045}}</option>
          </select>
        </div>-->
      </div>
    </confirmation-dialog>


    <!-- This modal is for the autovalidation result -->
    <div class="modal fade" id="autovalidationDialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >×</button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>Autovalidation</b>
            </h4>
          </div>
          <div class="modal-body" style="text-align: left">
            <div
              style="text-align: center"
              v-if="autovalidation.invalidChecks.length == 0 && autovalidation.validatedChecks.length == 0"
            >
              <p>
                Do you want to autovalidate
                {{ selectedCheckIds.length }} checks?
              </p>
              <button
                type="button"
                class="btn btn-raised btn-default"
                data-dismiss="modal"
              >
                {{ lang.CM0036 }}
              </button>
              <button
                type="button"
                class="btn btn-raised btn-warning"
                @click="startAutovalidation()"
              >
                {{ lang.CM0037 }}
              </button>
            </div>
            <div v-if="autovalidation.invalidChecks.length > 0">
              <h3>Invalid Checks</h3>
              <div class="autovalidationTable">
                <b-table
                  striped
                  hover
                  :items="autovalidation.invalidChecks"
                ></b-table>
              </div>
            </div>
            <br />
            <div v-if="autovalidation.validatedChecks.length > 0">
              <h3>Validated Checks</h3>
              <div class="autovalidationTable">
                <b-table
                  class="autovalidationTable"
                  striped
                  hover
                  :items="autovalidation.validatedChecks"
                ></b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

import CheckManagementEditModal from "./CheckManagementEditModal";
import CheckManagementAddModal from "./CheckManagementAddModal";
import CheckManagementFilterModal from "./CheckManagementFilterModal";
import ConfirmationDialog from "../Tools/Dialogs/ConfirmationDialog";
import SettlementDownloadModal from "./SettlementDownloadModal";
import CheckPaymentModal from "./CheckPaymentModal";
import ShopperFilterModal from "./ShopperFilterModal";
import CheckLocalAgencyAssignmentModal from "./CheckLocalAgencyAssignmentModal";
import Select2 from "../Tools/Select2";

import * as SurveyVue from "survey-vue";
import { error } from "jquery";


export default {
  name: "CheckManagement",
  components: {
    CheckManagementEditModal,
    CheckManagementAddModal,
    CheckManagementFilterModal,
    ConfirmationDialog,
    SettlementDownloadModal,
    CheckPaymentModal,
    ShopperFilterModal,
    CheckLocalAgencyAssignmentModal,
    Select2,
  },
  created() {
    this.globals.$off("openShopperFilterModal");
    this.globals.$on("openShopperFilterModal", () => {
      this.showShopperFilterModal = true;
    });
  },
  mounted() {
    this.readComponentSettingsFromStore();

    if (this.globals.selectedLanguage)
      this.globals.getLanguageStrings(this, this.setElementHeights);
    this.getCheckData();
    this.getDataLists();
    this.getCustomSettingsList();
    $(window).on("resize", this.setElementHeights).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setElementHeights);
  },
  destroyed() {
    $(window).off("resize", this.setElementHeights);
    this.writeComponentSettingsToStore();
  },
  methods: {
    setElementHeights() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#checks-top-panel").height() +
          $("#app-navbar").height() +
          $(".main-table > thead").height() +
          47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);

        height = $(window).height();
        height -= $(".main-table > thead").height() + 390;
        $("#create-checks-table").css("max-height", height);
        height += 85;
        $("#check-list-table").css("max-height", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      let restoreDone = () => {
        if (this.$refs.clientSelect) this.$refs.clientSelect.updateValue();
        if (this.$refs.importerSelect) this.$refs.importerSelect.updateValue();
        if (this.$refs.projectSelect) this.$refs.projectSelect.updateValue();

        delete this.$filterRestorePending;
        this.getCheckData();
      };

      let restoreFilters = () => {
        this.$nextTick(() => {
          let storedData = this.$store.getters["localFilters/checkManagement"];
          if (storedData) {
            for (let key in storedData) {
              if (key === "selectedClient")
                this.onClientSelection(storedData[key]);
              else if (_.has(this, key))
                this[key] = _.cloneDeep(storedData[key]);
            }
          }

          if (!this.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (!this.feature.isAudiTarget) {
            let storedClient = this.$store.getters["sharedFilters/client"];
            this.onClientSelection(storedClient.ClientGuid || "");
          } else {
            this.onClientSelection();

            let storedImporter = this.$store.getters["sharedFilters/importer"];
            this.selectedImporter = storedImporter.ImporterGuid || "";
          }

          let storedProject = this.$store.getters["sharedFilters/project"];
          this.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };

      let eventsToWaitFor = [
        "ClientListReceived",
        "ProjectListReceived",
        "StatusListReceived",
      ];
      if (this.feature.isAudiTarget)
        eventsToWaitFor.push("ImporterListReceived");
      this.globals.doAfterEvents(eventsToWaitFor, restoreFilters, this);
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/checkManagement", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        selectedCheckType: this.selectedCheckType,
        selectedOnlineState: this.selectedOnlineState,
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize,
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        if (this.selectedClient) {
          let client = _.find(this.dataLists.clientList, (c) => {
            return c.ClientGuid === this.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          let storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid)
            this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          let importer = _.find(this.dataLists.importerList, (i) => {
            return i.ImporterGuid === this.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          let storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid)
            this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        let project = _.find(this.dataLists.projectsOfClient, (p) => {
          return p.ProjectGuid === this.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        let storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid)
          this.$store.commit("sharedFilters/project");
      }
    },
    getCustomSettingsList() {
      $.ajax({
        method: "GET",
        url: "api/Data/CustomSettings",
        success: (data) => {
          this.CheckManagementFilter = data;
          this.getCountOfCheckManagementFilter();
        },
        error: () => {
          console.error(
            "Custom settings data access failed in getCustomSettingsList()"
          );
          this.globals.showErrorSnackbar("Custom settings data access failed");
        },
      });
    },
    getCountOfCheckManagementFilter() {
      for (const [key, value] of Object.entries(this.CheckManagementFilter)) {
        if (value == true) this.CheckManagementFilterCounter++;
      }
    },
    getNameOfSelectedClient() {
      if (this.dataLists.clientList.length < 1) return "";
      let currentClient = this.dataLists.clientList.filter((c) => {
        return c.ClientGuid == this.selectedClient;
      });
      if (currentClient.length < 1) return "";
      return currentClient[0].ClientName;
    },
    downloadCheckData() {
      let param =
        this.selectedClient + "?file_type=" + this.checkExportFileType;

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Export/" + param,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.length > 0 && data[0].DownloadId)
            this.globals.downloadFile(data[0].DownloadId);

          this.showExportModal = false;
        },
        error: (error) => {
          console.error("Error on POST in downloadCheckData()");
          this.globals.showErrorSnackbar("Check export failed");
        },
      });
    },
    onAddChecksDialogDataSaved() {
      // this.getCheckData(); // Refresh datatable
    },
    onAddChecksDialogClosed() {
      this.showAddChecksDialog = false;
      this.getCheckData();
    },
    onEditChecksDialogClosed() {
      this.showEditChecksDialog = false;
      this.$nextTick(() => {
        this.getCheckData();
      });
    },
    onFilterChecksDialogClosed() {
      this.showCheckManagementFilterModal = false;
    },
    onClientSelection(client) {
      if (client) this.selectedClient = client;
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getProjectsOfSelectedClient();
      if (
        _.findIndex(
          this.dataLists.projectsOfClient,
          (p) => p.ProjectGuid === this.selectedProject
        ) < 0
      )
        this.selectedProject = "";
    },
    onProjectSelection(project) {
      if (project) this.selectedProject = project;
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getCheckData();
    },
    toggleOnlineStateFilter() {
      if (typeof this.selectedOnlineState !== "boolean")
        this.selectedOnlineState = true;
      else if (this.selectedOnlineState) this.selectedOnlineState = false;
      else this.selectedOnlineState = null;

      this.getCheckData();
    },
    getProjectsOfSelectedClient() {
      this.dataLists.projectsOfClient = [];
      if (!this.selectedClient) return;

      let pl = this.dataLists.projectList.find((p) => {
        return p.ClientGuid === this.selectedClient;
      });
      if (pl && pl.Projects) this.dataLists.projectsOfClient = pl.Projects;
    },
    cloneSelectedChecks() {
      if (this.selectedChecks.length < 1) return;
      let sendData = [];
      for (let guid of this.selectedChecks) {
        sendData.push({ SurveyInstanceGuid: guid });
      }

      $.ajax({
        method: "POST",
        url: `/api/SurveyInstances/AgencyClone`,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.selectedChecks = [];
          this.selectedCheckIds = [];
          for (let check of data) {
            this.selectedChecks.push(check.SurveyInstanceGuid);
            this.selectedCheckIds.push(check.SurveyInstanceId);
          }
          this.getCheckData();
          this.globals.showSuccessSnackbar(this.lang.CM0077);
        },
        error: (error) => {
          console.error("Error on POST in cloneSelectedChecks()");
          this.globals.showErrorSnackbar(this.lang.CM0078);
        },
      });
    },
    showCheckHistory() {
      if (!this.selectedChecks[0] || !this.selectedCheckIds[0]) return;
      let config = {
        type: "SurveyInstance",
        guid: this.selectedChecks[0],
        id: this.selectedCheckIds[0],
      };
      this.globals.$emit("showElementHistory", config);
    },
    openCheck(id) {
      let newWindow = window.open(`/#/surveyview/${id}`);
      newWindow.onbeforeunload = () => {
        this.getCheckData();
      };
      newWindow.openerVueInstance = this;
    },
    openChecks(force) {
      if (!force && this.selectedChecks.length > 3) {
        this.globals.$off("OpenMultipleChecksModalYesConfirmation");
        this.globals.$on("OpenMultipleChecksModalYesConfirmation", () => {
          this.openChecks(true);
        });

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "OpenMultipleChecksModal",
          confirmationTitle: this.lang.CM0053,
          colorRed: true,
          yesButtonText: this.lang.CM0054,
          noButtonText: this.lang.CM0055,
          htmlText: `<p><b>${this.lang.CM0056}:
            ${this.selectedChecks.length}<br>
            <br>${this.lang.CM0057}<br>
            <br>${this.lang.CM0058}</b></p>`,
        });
        return;
      }

      for (let id of this.selectedCheckIds) {
        this.openCheck(id);
      }
    },
    calcAllowedStatusCodes() {
      if (this.filterStrings.SurveyInstanceStatusId.toString().length < 2)
        this.allowedStatusCodes = [];
      else {
        this.allowedStatusCodes = _.find(this.dataLists.statusCodes, (s) => {
          return (
            s.SurveyInstanceStatusId ==
            this.filterStrings.SurveyInstanceStatusId
          );
        }).SurveyInstanceFollowUpStatusses;
        if (!this.allowedStatusCodes) this.allowedStatusCodes = [];
      }

      this.selectedStatusCode = null;
    },
    getStatusCodeDescription(code) {
      let statusCodeObject = _.find(this.dataLists.statusCodes, (c) => {
        return c.SurveyInstanceStatusId === code;
      });
      if (statusCodeObject)
        return statusCodeObject.SurveyInstanceStatusDescription;
      else return code.toString();
    },
    getSurveyList() {
      $.ajax({
        method: "GET",
        url: "api/Data/projectssurveys",
        success: (data) => {
          this.dataLists.surveyList = data;
        },
        error: () => {
          console.error("Survey data access failed in getSurveyList()");
          this.globals.showErrorSnackbar("Survey data access failed");
        },
      });
    },
    getDataLists() {
      this.globals.getProjectList((data) => {
        this.dataLists.projectList = data;
        this.$emit("ProjectListReceived");
        this.getProjectsOfSelectedClient();
      });
      this.globals.getWaveList((data) => {
        this.dataLists.waveList = data;
      });
      this.globals.getScenarioList((data) => {
        this.dataLists.scenarioList = data;
      });
      this.getSurveyList();
      this.globals.getAgencyList((data) => {
        this.dataLists.agencyList = [];
        if (data && data[0]) this.dataLists.agencyList = data;
      });
      this.globals.getShopperList((data) => {
        this.dataLists.shopperList = data;
      });
      this.globals.getSurveyInstancesStatusList((callbackData) => {
        this.dataLists.statusCodes = callbackData;
        this.$emit("StatusListReceived");
      });
      this.globals.getClientList((data) => {
        this.dataLists.clientList = data;
        if (
          this.feature.isAudiTarget &&
          this.feature.isEnabled("audi_importers") &&
          data &&
          data[0]
        )
          this.onClientSelection(data[0].ClientGuid);
        this.$emit("ClientListReceived");
      });

      if (
        this.feature.isAudiTarget &&
        this.feature.isEnabled("audi_importers")
      ) {
        this.globals.getImporterList((data) => {
          this.dataLists.importerList = data;
          this.$emit("ImporterListReceived");
        });
      }
    },
    // Calculates the sort order for the given column and refreshes the displayed data
    sortCheckData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getCheckData();
    },
    // Catches check data for the table from the server, including current filter, pagination and sort settings
    getCheckData() {
      if (this.$filterRestorePending) return;
      this.refreshEnabled = false;

      let query = `api/SurveyInstances/Get?page_size=${this.pageSize}&page=${this.selectedPage}&sort_column=${this.sortField}&sort_order=${this.sortOrder}`;

      let body = { Filter: {} };
      for (let key in this.filterStrings) {
        if (this.filterStrings[key].length > 0)
          body.Filter[key] = this.filterStrings[key];
      }
      if (this.selectedClient) body.Filter.ClientGuid = this.selectedClient;
      if (this.selectedProject) body.Filter.ProjectGuid = this.selectedProject;
      if (this.selectedImporter)
        body.Filter.ImporterGuid = this.selectedImporter;
      if (this.selectedCheckType)
        body.Filter.SurveyInstanceType = this.selectedCheckType;
      if (
        this.selectedCheckType === "FO" &&
        typeof this.selectedOnlineState === "boolean"
      )
        body.Filter.OnlineState = this.selectedOnlineState;

      $.ajax({
        method: "POST",
        url: query,
        data: _.isEmpty(body.Filter) ? "" : JSON.stringify(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data[0]) {
            if (data[0].SurveyInstances)
              this.checkData = data[0].SurveyInstances;
            else this.checkData = [];
            this.pageCount = data[0].Page_Count;
            this.checkCount = data[0].Count;
          }
        },
        error: (error) => {
          console.error("Error on POST in getCheckData()");
          this.globals.showErrorSnackbar(this.lang.CM0062);
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    // Toggles the selected-state of a given check.
    // If the check is not yet selected, it will be added to the array of selected checks.
    // If the check is already selected, it will be removed from that array.
    selectCheck(checkGuid, checkId, e) {
      if (!e) return;

      if (e.ctrlKey && !e.shiftKey) {
        let idx = _.indexOf(this.selectedChecks, checkGuid);
        if (idx > -1) {
          _.pullAt(this.selectedChecks, idx);
          _.remove(this.selectedCheckIds, (id) => id === checkId);
          this.lastSelectedCheck = "";
        } else {
          this.selectedChecks.push(checkGuid);
          this.selectedCheckIds.push(checkId);
          this.lastSelectedCheck = checkGuid;
        }
      } else if (!e.ctrlKey && e.shiftKey) {
        document.getSelection().removeAllRanges();
        if (!this.lastSelectedCheck) return;

        let idx1 = _.findIndex(this.checkData, (c) => {
          return c.SurveyInstanceGuid === this.lastSelectedCheck;
        });
        let idx2 = _.findIndex(this.checkData, (c) => {
          return c.SurveyInstanceGuid === checkGuid;
        });

        if (idx1 > idx2) {
          let tmp = idx1;
          idx1 = idx2;
          idx2 = tmp;
        }

        for (let i = idx1; i <= idx2; i++) {
          if (!this.isCheckSelected(this.checkData[i].SurveyInstanceGuid)) {
            this.selectedChecks.push(this.checkData[i].SurveyInstanceGuid);
            this.selectedCheckIds.push(this.checkData[i].SurveyInstanceId);
          }
        }
      } else {
        this.selectedChecks = [checkGuid];
        this.selectedCheckIds = [checkId];
        this.lastSelectedCheck = checkGuid;
      }
      this.selectedStatusCode = null;
      this.$forceUpdate();
    },
    clearLastSelection() {
      this.lastSelectedCheck = "";
    },
    // Returns true if the given check is selected, otherwise false is returned.
    isCheckSelected(checkGuid) {
      return _.indexOf(this.selectedChecks, checkGuid) > -1;
    },
    isPageSelected() {
      for (let check of this.checkData) {
        if (!this.isCheckSelected(check.SurveyInstanceGuid)) return false;
      }
      return true;
    },
    togglePageSelected() {
      if (this.checkData.length < 1) return;
      let selState = this.isPageSelected();
      if (!selState) {
        for (let check of this.checkData) {
          if (!this.isCheckSelected(check.SurveyInstanceGuid)) {
            this.selectedChecks.push(check.SurveyInstanceGuid);
            this.selectedCheckIds.push(check.SurveyInstanceId);
          }
        }
      } else {
        for (let check of this.checkData) {
          _.remove(
            this.selectedChecks,
            (guid) => guid === check.SurveyInstanceGuid
          );
          _.remove(
            this.selectedCheckIds,
            (id) => id === check.SurveyInstanceId
          );
        }
        this.$forceUpdate();
      }
    },
    changeSelectedChecksStatus() {
      if (!this.selectedStatusCode || this.selectedCheckIds.length === 0)
        return;

      let sendData = {};
      sendData.SurveyInstanceIds = this.selectedCheckIds;
      sendData.SurveyInstanceStatusId = this.selectedStatusCode;

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances",
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) this.globals.showErrorSnackbar(data.Error);
          else {
            this.globals.showSuccessSnackbar("Status update successful");
            this.getCheckData();
            this.selectedStatusCode = null;
          }
        },
        error: () => {
          console.error("Error on PUT in changeSelectedChecksStatus()");
          this.globals.showErrorSnackbar("Status update failed");
        },
      });
    },
    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getCheckData();
    },
    // Returns a range of numbers with min-value, max-value and stepsize
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showAutovalidationDialog() {
      $("#autovalidationDialog").modal("show");

      $("#autovalidationDialog").on("hidden.bs.modal", (e) => {
        this.autovalidation.invalidChecks = [];
        this.autovalidation.validatedChecks = [];
      });
    },
    async startAutovalidation() {
      
      this.configureSurveyJs();

      this.autovalidation.invalidChecks = [];
      this.autovalidation.validatedChecks = [];

      var checksToValidate = [];

      if (this.selectedChecks.length > 0) {
        try {
          let res = [];
          for (let key in this.selectedChecks) {
            try {
              const r = await this.getOneSurveyAndSurveyInstanceJson(this.selectedChecks[key]);
              res = res.concat(r);
            } catch (e) {
              console.error("Check data access failed in getSurveyAndSurveyInstanceJson()", e);
              this.globals.showErrorSnackbar("Check data access failed");
            }
          }

          res.forEach((e) => {
            if (
              e.SurveyInstanceStatusId <= 200 &&
              e.SurveyInstanceStatusId > 100
            ) {
              e.Survey = JSON.parse(e.Survey);
              e.SurveyInstanceAnswer = JSON.parse(e.SurveyInstanceAnswer);
              e.SurveyInstanceAnswerPosition = JSON.parse(e.SurveyInstanceAnswerPosition);
              checksToValidate.push(e);
            } else {
              this.autovalidation.invalidChecks.push({
                SID: e.SurveyId,
                CheckID: e.SurveyInstanceId,
                Status: e.SurveyInstanceStatusId,
              });
            }
          });
          for (var key in checksToValidate) {
            await this.validateCheck(checksToValidate[key]);
            this.globals.showSuccessSnackbar(
              parseInt(key) +
                1 +
                "/" +
                this.selectedChecks.length +
                " checks finished!"
            );
          }
        } catch (err) {
          console.error("Error in autovalidation");
          console.error(err);
        }
        this.getCheckData();
        $("#autovalidationDialog").modal("show");
      } else {
        this.globals.showErrorSnackbar("No checks selected");
      }
    },
    async getOneSurveyAndSurveyInstanceJson(id) {
      return $.ajax({
        method: "POST",
        url: "api/SurveyInstances/SurveyAndSurveyInstanceJsons/",
        dataType: "json",
        data: JSON.stringify([id]),
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          return data;
        },
        error: (error) => {
          console.error("Error on POST in getOneSurveyAndSurveyInstanceJson()", error);
          this.globals.showErrorSnackbar("Check validation failed");
        },
      });
    },
    getSurveyAndSurveyInstanceJson() {
      return new Promise((resolve, reject) => {
        var query = "api/SurveyInstances/SurveyAndSurveyInstanceJsons/";
        $.ajax({
          method: "POST",
          url: query,
          data: JSON.stringify(this.selectedChecks),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            resolve(data);
          },
          error: () => {
            console.error(
              "Check data access failed in getSurveyAndSurveyInstanceJson()"
            );
            this.globals.showErrorSnackbar("Check data access failed");
            reject();
          },
        });
      });
    },
    async validateCheck(check) {
      this.autovalidation.survey = new SurveyVue.Model(check.Survey);

      this.autovalidation.survey.data = check.SurveyInstanceAnswer;
      // this.autovalidation.survey.runTriggers(); // does not exist in currently used old version of survey.js

      var pageIndex = 0; // Start from the first page
      this.autovalidation.survey.currentPageNo = pageIndex; // Set the current page to the first page

      // Iterate through all pages
      while (pageIndex < this.autovalidation.survey.pages.length - 1) {
        this.autovalidation.survey.nextPage();
        pageIndex++;
      }

      // After reaching the last page, you can optionally call completeLastPage if needed
      var hasErrors = !this.autovalidation.survey.completeLastPage();

      if (
        // this.autovalidation.survey.hasErrors() ||
        hasErrors || 
        check.SurveyInstanceAnswerDateOfVisit == null ||
        check.SurveyInstanceAnswerTimeIn == null ||
        check.SurveyInstanceAnswerTimeOut == null
      ) {
        this.autovalidation.invalidChecks.push({
          SID: check.SurveyId,
          CheckID: check.SurveyInstanceId,
          Status: check.SurveyInstanceStatusId,
        });
      } else {
        // clean surveyanswers
        this.cleanupSurveyAnswer();
        // calc new progress
        check.SurveyInstanceProgress = this.calcSurveyProgress(
          this.autovalidation.survey,
          check
        );
        // calc Points
        this.calcPointsOfContainer(this.autovalidation.survey);

        var newStatus;
        switch (true) {
          case check.SurveyInstanceStatusId === 110:
            newStatus = 120;
            break;
          case check.SurveyInstanceStatusId === 130:
            newStatus = 140;
            break;
          case ((check.SurveyInstanceStatusId === 120 || check.SurveyInstanceStatusId === 140) && this.globals.currentUserRole > 1):
            newStatus = 160;
            break;
          case check.SurveyInstanceStatusId === 150:
            newStatus = 165;
            break;
          case _.includes([120, 140, 160, 165, 170, 190], check.SurveyInstanceStatusId):
            newStatus = 200;
            break;
          case check.SurveyInstanceStatusId === 200:
            newStatus = 200;
            break;
          default:
            break;
        }
        if (newStatus) {
          try {
            // save surveyInstanceAnswers
            await this.saveSurveyInstanceAnswers(check);
            // update status
            if (!(newStatus === 200 && check.SurveyInstanceStatusId === 200)) {
              await this.updateCheckStatus(newStatus, check.SurveyInstanceId);
            }
            this.autovalidation.validatedChecks.push({
              SID: check.SurveyId,
              CheckID: check.SurveyInstanceId,
              "Status old": check.SurveyInstanceStatusId,
              "Status New": newStatus,
            });
          } catch (err) {
            console.error("Error in saveSurveys");
            console.error(err);
            this.globals.showErrorSnackbar(
              "saving survey instance " + check.SurveyInstanceId + " failed"
            );
          }
        }
      }
      this.autovalidation.survey = null;
      return;
    },
    saveSurveyInstanceAnswers(check) {
      let queryString = `api/SurveyInstancesAnswers/ViaAutovalidation/${check.SurveyInstanceId}`;

      let surveyObject = _.clone(check);
      delete surveyObject.Survey;
      delete surveyObject.SurveyId;
      delete surveyObject.SurveyInstanceGuid;
      delete surveyObject.SurveyInstanceId;
      delete surveyObject.SurveyInstanceStatusId;
      surveyObject.SurveyInstanceAnswer = _.cloneDeep(
        this.autovalidation.survey.data
      );
      surveyObject.SurveyInstanceAnswerMaxPoints =
        this.autovalidation.survey.pointsMax;
      surveyObject.SurveyInstanceAnswerPoints =
        this.autovalidation.survey.pointsReached;

      return new Promise((resolve, reject) => {
        $.ajax({
          method: "PUT",
          url: queryString,
          data: JSON.stringify(surveyObject),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              reject(`Server Error:${data.Error}`);
            }
            resolve(data);
          },
          error: (error) => {
            reject(error);
          },
        });
      });
    },
    updateCheckStatus(status, id) {
      if (!status) return;
      let sendData = {};
      sendData.SurveyInstanceIds = [id];
      sendData.SurveyInstanceStatusId = status;
      let queryString = "api/SurveyInstances";

      return new Promise((resolve, reject) => {
        $.ajax({
          url: queryString,
          type: "PUT",
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              reject(`Server Error:${data.Error}`);
            }
            resolve(data);
          },
          error: (error) => {
            reject(error);
          },
        });
      });
    },
    calcSurveyProgress(survey, check) {
      let requiredFields = [
        "SurveyInstanceAnswerDateOfVisit",
        "SurveyInstanceAnswerTimeIn",
        "SurveyInstanceAnswerTimeOut",
      ];
      let visibleQuestions = survey.getAllQuestions(true);
      let requiredCount = 0;
      let answeredCount = 0;
      for (let i = 0; i < visibleQuestions.length; i++) {
        if (visibleQuestions[i].isRequired) {
          requiredCount++;
          if (!visibleQuestions[i].isEmpty()) answeredCount++;
        }
      }
      requiredCount += requiredFields.length;
      requiredFields.forEach((field) => {
        if (check[field] !== "") {
          answeredCount++;
        }
      });
      let result = Math.round((answeredCount / requiredCount) * 100);
      return result;
    },
    configureSurveyJs() {
      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      SurveyVue.FunctionFactory.Instance.register("setMaxPoints", (params) => {
        if (params.length < 1 || !this.autovalidation.survey) return;
        for (let i = 0; i < params.length; i++) {
          let q = this.autovalidation.survey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      SurveyVue.FunctionFactory.Instance.register(
        "unsetMaxPoints",
        (params) => {
          if (params.length < 1 || !this.autovalidation.survey) return;
          for (let i = 0; i < params.length; i++) {
            let q = this.autovalidation.survey.getQuestionByName(params[i]);
            if (q && q.maxPointsReached) q.maxPointsReached = false;
          }
        }
      );
      SurveyVue.JsonObject.metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean",
      });
      SurveyVue.JsonObject.metaData.addProperty("panel", {
        name: "isCluster:boolean",
      });
      SurveyVue.JsonObject.metaData.addProperty("panel", {
        name: "backgroundColor:text",
      });
      SurveyVue.JsonObject.metaData.addProperty(
        "question",
        "commentForShopper:text"
      );

      SurveyVue.JsonObject.metaData.addProperty(
        "checkbox",
        "exclusiveValue:checkboxValue"
      );

      // Add points to answers
      SurveyVue.JsonObject.metaData.addClass(
        "itemvaluesWithPoints",
        ["points:number"],
        null,
        "itemvalue"
      );
      SurveyVue.JsonObject.metaData.addProperty(
        "selectbase",
        "choices:itemvalues"
      );
      let property1 = SurveyVue.JsonObject.metaData.findProperty(
        "selectbase",
        "choices"
      );
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      SurveyVue.JsonObject.metaData.addProperty(
        "rating",
        "rateValues:itemvalues"
      );
      property1 = SurveyVue.JsonObject.metaData.findProperty(
        "rating",
        "rateValues"
      );
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      SurveyVue.JsonObject.metaData.addClass(
        "itemvaluesWithPointsAndMaxPoints",
        ["points:number", "maxPoints:number"],
        null,
        "itemvalue"
      );
      SurveyVue.JsonObject.metaData.addProperty(
        "radiogroup",
        "choices:itemvalues"
      );
      let property2 = SurveyVue.JsonObject.metaData.findProperty(
        "radiogroup",
        "choices"
      );
      property2.typeValue = "itemvaluesWithPointsAndMaxPoints";
      property2.className = "itemvaluesWithPointsAndMaxPoints";

      SurveyVue.JsonObject.metaData.addProperty("question", {
        name: "pointsMax:number",
      });

      SurveyVue.JsonObject.metaData.addProperty("question", "guid");
      SurveyVue.JsonObject.metaData.addProperty("panelbase", "guid");
      SurveyVue.JsonObject.metaData.addProperty("itemvalue", "guid");

      // Add custom question numbers
      SurveyVue.JsonObject.metaData.addProperty("question", {
        name: "customQuestionNumber",
        default: 0,
      });

      // Add properties for currency inputs
      SurveyVue.JsonObject.metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€",
      });
      SurveyVue.JsonObject.metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma",
      });
    },
    calcPointsOfContainer(container) {
      let type = container.getType();
      let containerTypes = ["panel", "page", "survey"];

      if (_.indexOf(containerTypes, type) < 0) return; // No container type
      container.pointsMax = 0;
      container.pointsReached = 0;
      let elements = type === "survey" ? container.pages : container.elements;

      for (let el of elements) {
        if (_.indexOf(containerTypes, el.getType()) > -1) {
          this.calcPointsOfContainer(el);
          container.pointsMax += el.pointsMax || 0;
          container.pointsReached += el.pointsReached || 0;
        } else {
          let qpoints = this.getPointsOfQuestion(el);
          container.pointsMax += qpoints.pointsMax;
          container.pointsReached += qpoints.pointsReached;
        }
      }
    },
    // Returns the points of a given question
    getPointsOfQuestion(question) {
      let points = { pointsMax: 0, pointsReached: 0 };
      let qtype = question.getType();
      if (!qtype || typeof question.value === "undefined") return points;

      if (_.indexOf(["text", "comment", "file"], qtype) > -1) {
        if (question.pointsMax) {
          points.pointsMax = question.pointsMax;
          points.pointsReached = question.pointsMax;
        }
      } else if (qtype === "checkbox") {
        if (question.value.length > 0) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          for (let item of question.value) {
            let answer = _.find(question.choices, {
              value: item,
            });
            if (answer && answer.points) points.pointsReached += answer.points;
          }
        }
      } else if (qtype === "radiogroup") {
        let answer = _.find(question.choices, { value: question.value });
        if (answer) {
          if (answer.maxPoints) points.pointsMax = answer.maxPoints;
          else if (question.pointsMax) points.pointsMax = question.pointsMax;

          if (answer.points) points.pointsReached = answer.points;
        }
      } else if (qtype === "dropdown") {
        let answer = _.find(question.choices, { value: question.value });
        if (answer) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          if (answer.points) points.pointsReached = answer.points;
        }
      } else if (qtype === "rating") {
        if (!question.rateValues || question.rateValues.length < 1) {
          if (question.pointsMax) {
            points.pointsMax = question.pointsMax;
            points.pointsReached = question.pointsMax;
          }
        } else {
          let answer = _.find(question.rateValues, { value: question.value });
          if (answer) {
            if (question.pointsMax) points.pointsMax = question.pointsMax;
            if (answer.points) points.pointsReached = answer.points;
          }
        }
      }
      return points;
    },
    showAutovalidationButton() {
      let role = this.globals.getUserRole();
      if (!role) {
        return false;
      }
      switch (role.RoleName) {
        case "MSM_Administrator_Sysadmin":
          return true;
        case "MSM_MSM_Administrator":
          return true;
        case "MSM_MSM_ProjectLeader_Senior":
          return true;
        default:
          return false;
      }
    },
    cleanupSurveyAnswer() {
      if (this.autovalidation.survey.clearInvisibleValues === "none") return;
      let visibleQuestions = this.autovalidation.survey.getAllQuestions(true);

      this.autovalidation.survey.data = _.pickBy(
        this.autovalidation.survey.data,
        (value, key) => {
          return _.findIndex(visibleQuestions, (q) => q.name === key) > -1;
        }
      );
    },
  },
  watch: {
    selectedClient() {
      if (!this.showAddChecksDialog) this.getCheckData();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
    },
    "filterStrings.SurveyInstanceStatusId"() {
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.includeChecks = true;
      this.calcAllowedStatusCodes();
      this.getCheckData();
    },
  },
  directives: {
    ClickOutside,
  },
  data() {
    // Global data inside the component is stored here
    return {
      selectedChecks: [], // GUIDs
      selectedCheckIds: [], // IDs TODO: Should be removed
      CheckManagementFilter: [],
      CheckManagementFilterCounter: 0,
      CheckManagementFilterWidthSID: 3,
      lastSelectedCheck: -1,
      includeChecks: true,
      selectedClient: "",
      selectedImporter: "",
      selectedProject: "",
      selectedCheckType: "",
      selectedOnlineState: null,
      pageSize: 20, // Number of checks on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      checkCount: 0,
      showEditChecksDialog: false,
      showCheckManagementFilterModal: false,
      showAddChecksDialog: false,
      showSettlementDownloadModal: false,
      showCheckPaymentModal: false,
      showShopperFilterModal: false,
      showCheckLocalAgencyAssignmentModal: false,
      checkExportFileType: "xlsx",
      showExportModal: false,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        ClientGuid: "",
        SurveyId: "",
        SurveyInstanceId: "",
        SurveyInstanceGuid: "",
        ShortSurveyCode: "",
        WaveName: "",
        SurveyInstanceStatusId: "",
        ProjectGuid: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCountry: "",
        SurveyInstanceAnswerDateOfVisit: "",
        SurveyInstanceShopperSubmittedAt: "",
        SurveyInstancePartnerSubmittedAt: "",
        SurveyInstanceNote: "",
        SurveyInstanceUntil: "",
        ScenarioName: "",
        SurveyInstanceInfo: "",
        SurveyInstanceResponsable: "",
        ApprovedShopperName: "",
        SurveyInstanceScore: "",
        SurveyInstanceProgress: "",
        SettlementNumber: "",
        SurveyInstanceModifiedAt: "",
      },
      sortField: "SurveyInstanceId", // Selected column for sorting
      sortOrder: "desc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if check data is requested and server did not respond yet to avoid multiple requests at the same time
      checkData: [], // Stores the check data on the current page
      dataLists: {
        clientList: [], // List of all clients
        importerList: [],
        surveyList: [], // List of all surveys
        statusCodes: [],
        projectList: [],
        projectsOfClient: [],
        waveList: [],
        scenarioList: [],
        agencyList: [],
        shopperList: {},
      },
      allowedStatusCodes: [],
      selectedStatusCode: null,
      invalidInputIds: [], // IDs of inputs with validation error
      metaInformationOfCurrentCheck: {},
      lang: {
        // Contains localization strings for the selected language
        CM0000: "Update",
        CM0001: "New",
        CM0002: "Edit",
        CM0003: "Delete",
        CM0004: "Export",
        CM0005: "Open",
        CM0006: "Move to Status",
        CM0007: "Select Page",
        CM0008: "Deselect Page",
        CM0009: "Invert Selection",
        CM0010: "Reset Selection",
        CM0011: "Please select a client...",
        CM0012: "Elements per page",
        CM0013: "First page",
        CM0014: "Last page",
        CM0015: "SID",
        CM0016: "Check ID",
        CM0017: "Survey Code",
        CM0018: "Status",
        CM0019: "Project",
        CM0020: "Wave",
        CM0021: "Scenario",
        CM0022: "Address",
        CM0023: "Country",
        CM0024: "Visit",
        CM0025: "Submit Shopper",
        CM0026: "Submit Partner",
        CM0027: "Internal note",
        CM0028: "Expiry Date",
        CM0029: "User",
        CM0030: "Score",
        CM0031: "Progress",
        CM0032: "Filter",
        CM0033: "Survey View",
        CM0034: "Delete Checks",
        CM0035: "Do you really want to delete the selected checks?",
        CM0036: "No",
        CM0037: "Yes",
        CM0038: "Check Export",
        CM0039: "Download",
        CM0040: "Cancel",
        CM0041: "Export Checks for Client",
        CM0042: "Please select a file type",
        CM0043: "Text CSV (.csv)",
        CM0044: "Microsoft Excel 97-2003 (.xls)",
        CM0045: "Microsoft Excel 2007-2013 XML (.xlsx)",
        CM0046: "Please filter for status first",
        CM0047: "Modified At",
        CM0048: "Please select a project...",
        CM0049: "Total checks count",
        CM0050: "StoreID",
        CM0051: "Location Name",
        CM0052: "Estimated - Relevant are the reporting results",
        CM0053: "Open multiple checks",
        CM0054: "Yes",
        CM0055: "No",
        CM0056: "You are trying to open the following amount of checks",
        CM0057:
          "Opening many checks at once can lead to performance issues until your browser will load multiple new tabs at once.",
        CM0058: "Do you really want to proceed?",
        CM0059: "Invoice lists",
        CM0060: "Invoice",
        CM0061: "Payments",
        CM0062: "Check request failed",
        CM0063: "Free offer",
        CM0064: "Manual assignment",
        CM0065: "Agency",
        CM0066: "Check type",
        CM0067: "Online",
        CM0068: "Meaning of the filterable values",
        CM0069: "Invoice approved",
        CM0070: "Submitted by shopper",
        CM0071: "Check is assigned",
        CM0072: "Partner check or no payout",
        CM0073: "Check Info",
        CM0074: "Importer",
        CM0075: "Assign",
        CM0076: "Clone",
        CM0077: "Checks cloned",
        CM0078: "Check cloning failed",
        CM0079: "Shopper",
        CM0080: "History",
        CM1074: "Custom settings",
      },
      autovalidation: {
        invalidChecks: [],
        validatedChecks: [],
        survey: null,
      },

    };
  },
};
</script>

<style>
#checkMgmtStatusFilterContainer > .select2.select2-container {
  margin: -1px 0 1px 0;
}
#checkMgmtStatusFilterContainer .select2-selection {
  background: transparent;
}
#checkMgmtStatusFilterContainer
  .select2-selection
  .select2-selection__rendered {
  text-align: center;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#checks-top-panel .top-button-bar {
  text-align: left;
}
#checks-top-panel .top-button-bar > div {
  padding-left: 5px;
}
#checks-top-panel .btn-top-bar {
  margin-right: 0;
}

.well-top-bar {
  height: 80px;
  margin: 5px 10px 0 0;
  padding: 10px 5px 0 30px;
}

.well-top-bar .selectbar,
.well-top-bar .selectbar > label,
.well-top-bar .selectbar > a,
.well-top-bar .selectbar > button {
  margin: 0 0 0 10px;
  display: inline;
}
.well-top-bar .selectbar > a,
.well-top-bar .selectbar > .btn-group > a,
.well-top-bar .selectbar .dropdown-menu {
  background-color: lightgray;
}
.well-top-bar .selectbar .dropdown-menu > li {
  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.well-top-bar .selectbar .dropdown-menu > li:hover {
  background-color: #e4e4e4;
}

.form-group.selectbar {
  margin: 0;
  padding: 0 0 7px 0;
}
.form-group.selectbar .form-control {
  margin-top: 10px;
}

.select-filter-container {
  width: 35%;
  padding-right: 10px;
  margin: 9px 0 3px 0;
  float: left;
}
.select-filter-container:last-child {
  width: 30%;
}
.width-15 {
  width: 15% !important;
}

table.main-table {
  font-size: 12px;
}

.filterbar > input {
  max-height: 35px;
  font-size: 12px;
}
.filterbar > input::placeholder {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// CheckManagement.vue?77bfa596